import React, {Component, createRef} from 'react';

// CSS


// Helper
import {checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Panel, Confirm } from '../../components/UI/Overlays';
import { EmptyState, TableWait, Chip, Tip } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FileUpload } from 'primereact/fileupload';

import { InputTextarea } from 'primereact/inputtextarea';

// Properties
const properties = require('../../properties.json');

class AddNews extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        // Submit Button
        buttonText: "إضافة خبر",
        buttonColor: "",

        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,
        companyID: properties.company_id,
        teacherId : null ,
        periodName: null ,
        globalFilter: null,
        userInput : null ,
        // Get Data
        data:[],
        allGrades : [],
        editableData : null ,
        dataId:[],
        selectedPeriod: null ,
        selectedPeriodId: null ,
        address : null ,
        post : null ,
        type : null ,
        active : null ,
        schoolStageId : null ,
        visible : false ,
        formContent: {
            branchId: getCurrentUser()?.branchId,
            companyId: properties.company_id,
            thumb: "",
        },

        // ---- the page's own states ----
        tableLoading: true,
        loadingStages: true,
        addOpen: false,
        saving: false,

        // the item the teacher asked to delete, held while the card is up
        doomed: null,
        deleting: false,
    }

    componentDidMount () {
        document.title = properties.site_name + " | الأخبار";
        this.allNews();
        // this.getPeriods();
       // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        };

        apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
        .then(grades => {
            this.setState({allGrades: grades, loadingStages: false});
        })
        .catch(error => {
            this.setState({loadingStages: false});
            console.error('Error:', error);
        });

        // Get Periods From API

    }
    allNews = () => {
        var _this = this ;
       // Send the data to the server
       this.setState({tableLoading: true});
       apiFetch("/news", { query: { teacherUserId: getCurrentUser()?.userId } })
       .then(done => {
        this.setState({data : done, tableLoading: false});

       })
       .catch(error => {
           console.error('Error:', error)
           this.setState({tableLoading: false});
           _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
       });
   };


   edit = () => {
    var _this = this ;
   // Send the data to the server
   this.setState({saving: true});
   apiFetch(`/news/${this.state.editableData.id}`, {
       method: "PUT",
       body: {
           type: this.state.editableData.newsType,
           post: this.state.editableData.post,
           img: this.state.editableData.img,
           address: this.state.editableData.address,
           schoolStageId: this.state.editableData.schoolStageId,
           branchId: this.state.branchID,
       },
   })
   .then(() => {
       _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تم التعديل بنجاح'});
       this.allNews();
       this.setState({visible: false, saving: false});
   })
   .catch(error => {
       console.error('Error:', error)
       this.setState({saving: false});
       _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
   });
};

     addNews = () => {
        var _this = this ;
       // Send the data to the server
       this.setState({saving: true});
       apiFetch("/news", {
           method: "POST",
           body: {
               type: this.state.type,
               post: this.state.post,
               img: this.state.formContent.thumb,
               address: this.state.address,
               schoolStageId: this.state.schoolStageId,
               branchId: this.state.branchID,
           },
       })
       .then(() => {
           _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تمت إضافة الخبر بنجاح'});
           this.allNews();
           // the card closes on a save that finished the job, and the list
           // behind it shows what was just written
           this.setState({
               saving: false,
               addOpen: false,
               address: null,
               post: null,
               type: null,
               active: null,
               schoolStageId: null,
               formContent: { ...this.state.formContent, thumb: "" },
           });
       })
       .catch(error => {
           console.error('Error:', error)
           this.setState({saving: false});
           _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
       });
   };



    render() {
        const { data, tableLoading, doomed, deleting, saving, editableData } = this.state;

        const typeList = [
            {label: 'عام', value: 0},
            {label: 'دفعه معينه', value: 1}
        ];

        const active = [
            {label: 'مفعل', value: 1},
            {label: 'غير مفعل', value: 0}
        ];
        const grades = this.state.allGrades.map(grade => {
            return {
                label: grade.name,
                value: grade.id
            }
        });

        const stageName = (id) => {
            const g = this.state.allGrades.find((s) => s.id === id);
            return g ? g.name : null;
        };

            const onUploadThumb = (e) => {
                let res = JSON.parse(e.xhr.response);
                this.setState({formContent: {
                    ...this.state.formContent,
                    thumb: res.thumb_url.split('/').pop()
                }});
                this.toast.current.show({severity: 'info', summary: 'تم بنجاح', detail: 'تم رفع الصورة المصغرة'});
            };

        var deletePeriod = (e) => {
            var _this = this;
            this.setState({deleting: true});
            // Send the data to the server
            apiFetch(`/news/${e.id}`, { method: "DELETE" })
            .then(() => {
                this.setState({doomed: null, deleting: false});
                _this.allNews();
                _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تم الحذف بنجاح'});
            })
            .catch(error => {
                console.error('Error:', error)

                _this.setState({
                   buttonText: "إضافة الخبر",
                   buttonColor: "",
                   doomed: null,
                   deleting: false
               });

               _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
            });
        };

        /**
         * One form, written once and filled twice: the add card reads and
         * writes the page's own fields, the edit card reads and writes the
         * row being edited. Every field, every option list and every upload
         * is the one that was already here.
         */
        const newsForm = (v, set, upload, img, clearImage) => (
            <>
                <section className="ui-sec">
                    <h3>
                        <span className="n">١</span>
                        <span className="t">
                            الخبر
                            <small>عنوانه، ونصه اللي هيقروه الطلاب</small>
                        </span>
                    </h3>

                    <div className="ui-fields">
                        <div className="f is-wide">
                            <span className="p-float-label">
                                <InputText
                                    id="news-address"
                                    value={v.address || ''}
                                    onChange={(e) => set('address', e.target.value)}
                                />
                                <label htmlFor="news-address">عنوان الخبر</label>
                            </span>
                        </div>

                        <div className="f is-wide">
                            <span className="p-float-label">
                                <InputTextarea
                                    id="news-post"
                                    rows={4}
                                    autoResize
                                    value={v.post || ''}
                                    onChange={(e) => set('post', e.target.value)}
                                />
                                <label htmlFor="news-post">
                                    نص الخبر
                                    <small className="ui-fieldhint"> (٢٥٠ حرف على الأكثر)</small>
                                </label>
                            </span>
                        </div>
                    </div>
                </section>

                <section className="ui-sec">
                    <h3>
                        <span className="n">٢</span>
                        <span className="t">
                            مين يشوفه
                            <small>نوع الخبر، وحالته، والمرحلة اللي هيظهر لها</small>
                        </span>
                    </h3>

                    <div className="ui-fields">
                        <div className="f">
                            <span className="p-float-label">
                                <Dropdown
                                    value={v.type}
                                    options={typeList}
                                    onChange={(e) => set('type', e.value)}
                                    name="type"
                                    placeholder="اختر"
                                />
                                <label>نوع الخبر</label>
                            </span>
                        </div>

                        <div className="f">
                            <span className="p-float-label">
                                <Dropdown
                                    value={v.active}
                                    options={active}
                                    onChange={(e) => set('active', e.value)}
                                    name="active"
                                    placeholder="اختر"
                                />
                                <label>حالة الخبر</label>
                            </span>
                        </div>

                        <div className="f">
                            <span className="p-float-label">
                                <Dropdown
                                    value={v.schoolStageId}
                                    options={grades}
                                    onChange={(e) => set('schoolStageId', e.value)}
                                    name="grade"
                                    placeholder="اختر"
                                    emptyMessage={<SelectEmpty loading={this.state.loadingStages} text="مفيش مراحل" />}
                                />
                                <label>المرحلة الدراسية</label>
                            </span>
                        </div>
                    </div>
                </section>

                <section className="ui-sec">
                    <h3>
                        <span className="n">٣</span>
                        <span className="t">
                            صورة الخبر
                            <small>اختيارية — بتظهر جنب الخبر على الموقع</small>
                        </span>
                    </h3>

                    <FileUpload
                        name="thumb"
                        onUpload={upload}
                        invalidFileSizeMessageSummary="حجم الصورة كبير:"
                        invalidFileSizeMessageDetail="أقصى حجم للصورة هو (100 MB)"
                        url={`${properties.uploads_path}/upload-thumb.php`}
                        customUpload={false}
                        multiple={false}
                        accept="image/*"
                        maxFileSize={1000000000}
                        chooseLabel="إختيار صورة"
                        uploadLabel="رفع الصورة"
                        cancelLabel="إلغاء"
                        emptyTemplate={<p className="p-m-0">إسحب الصورة هنا ليبدأ التحميل</p>}
                    />

                    {img ? (
                        <div className="ui-thumbrow">
                            <img
                                className="preview-thumb image"
                                src={`${properties.uploads_path}/thumb/${img}`}
                                alt=""
                                onClick={(e) => e.target.requestFullscreen()}
                            />
                            <button type="button" className="ui-btn is-secondary is-small" onClick={clearImage}>
                                <i className="pi pi-times"></i>
                                <span>حذف الصورة</span>
                            </button>
                        </div>
                    ) : null}
                </section>
            </>
        );

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="تعديل">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary p-ml-2" onClick={ () =>this.setState({visible: true , editableData : rowData , selectedPeriod : null})} />
                    </Tip>
                    <Tip text="حذف">
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => this.setState({ doomed: rowData })} />
                    </Tip>
                </React.Fragment>
            );
        }

        // the news item as it reads on the site: its picture, its title, and
        // the first line of it underneath
        const newsBody = (row) => (
            <span className="ui-row-lead">
                {row.img ? (
                    <img className="thumb" src={`${properties.uploads_path}/thumb/${row.img}`} alt="" loading="lazy" />
                ) : (
                    <span className="thumb is-empty" aria-hidden="true">
                        <i className="pi pi-megaphone"></i>
                    </span>
                )}
                <span className="tx">
                    <b>{row.address || 'من غير عنوان'}</b>
                    <small>{row.post || 'من غير نص'}</small>
                </span>
            </span>
        );

        const whoBody = (row) => (
            <span className="ui-stack">
                <b>{Number(row.type) === 1 ? 'دفعة معينة' : 'عام'}</b>
                <small>{stageName(row.schoolStageId) || 'كل المراحل'}</small>
            </span>
        );

        return (
            <>
                <Header
                    pageName="الأخبار"
                    action={{ label: "خبر جديد", icon: "pi pi-plus", onClick: () => this.setState({ addOpen: true }) }}
                />
                <Toast ref={this.toast}></Toast>

                {/* adding and editing happen over the list, in the same form */}
                <Panel
                    visible={this.state.addOpen}
                    onHide={() => this.setState({ addOpen: false })}
                    title="خبر جديد"
                    subtitle="اكتبه، حدّد مين يشوفه، وارفع صورته"
                    actions={
                        <button
                            type="button"
                            className="ui-btn is-gold"
                            disabled={saving || !String(this.state.address || '').trim()}
                            onClick={this.addNews}
                        >
                            {saving ? <i className="pi pi-spin pi-spinner"></i> : <i className="pi pi-check"></i>}
                            <span>{saving ? 'جاري الحفظ…' : 'إضافة الخبر'}</span>
                        </button>
                    }
                >
                    {newsForm(
                        this.state,
                        (k, val) => this.setState({ [k]: val }),
                        onUploadThumb,
                        this.state.formContent.thumb,
                        () => this.setState({ formContent: { ...this.state.formContent, thumb: "" } })
                    )}
                </Panel>

                <Panel
                    visible={this.state.visible}
                    onHide={() => this.setState({ visible: false })}
                    title="تعديل الخبر"
                    subtitle={editableData ? editableData.address : ''}
                    actions={
                        <button
                            type="button"
                            className="ui-btn is-gold"
                            disabled={saving || !editableData}
                            onClick={() => (editableData ? this.edit() : null)}
                        >
                            {saving ? <i className="pi pi-spin pi-spinner"></i> : <i className="pi pi-check"></i>}
                            <span>{saving ? 'جاري الحفظ…' : 'حفظ التعديل'}</span>
                        </button>
                    }
                >
                    {editableData
                        ? newsForm(
                              {
                                  address: editableData.address,
                                  post: editableData.post,
                                  type: editableData.newsType,
                                  active: editableData.active,
                                  schoolStageId: editableData.schoolStageId,
                              },
                              (k, val) =>
                                  this.setState({
                                      editableData: { ...this.state.editableData, [k === 'type' ? 'newsType' : k]: val },
                                  }),
                              (e) => {
                                  let res = JSON.parse(e.xhr.response);
                                  this.setState({ editableData: { ...this.state.editableData, img: res.thumb_url } });
                                  this.toast.current.show({ severity: 'info', summary: 'تم بنجاح', detail: 'تم رفع الصورة المصغرة' });
                              },
                              editableData.img,
                              () =>
                                  this.setState({
                                      editableData: { ...this.state.editableData, img: "" },
                                      formContent: { ...this.state.formContent, thumb: "" },
                                  })
                          )
                        : null}
                </Panel>

                <Confirm
                    visible={!!doomed}
                    onHide={() => this.setState({ doomed: null })}
                    name={doomed ? doomed.address : ''}
                    note="الخبر هيتشال من الموقع نهائياً، ومش هينفع ترجع عنه."
                    busy={deleting}
                    onConfirm={() => deletePeriod(doomed)}
                />

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                <Toolbar
                                    value={this.state.globalFilter || ''}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث في الأخبار"
                                    count={tableLoading ? null : `${data.length} خبر`}
                                />

                                <DataTable
                                sortable
                                globalFilter={this.state.globalFilter}
                                 className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                  value={data} paginator rows={10} rowsPerPageOptions={[10,20,50]}
                                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                   emptyMessage={
                                       tableLoading ? (
                                           <TableWait />
                                       ) : (
                                           <EmptyState
                                               title="مفيش أخبار"
                                               hint="اكتب أول خبر، وهيظهر لطلابك على الموقع"
                                               icon="pi pi-megaphone"
                                               action={{ label: "خبر جديد", onClick: () => this.setState({ addOpen: true }) }}
                                           />
                                       )
                                   }>
                                    <Column sortable field="address" header="الخبر" body={newsBody}></Column>
                                    <Column
                                        sortable
                                        field="type"
                                        header="مين يشوفه"
                                        body={whoBody}
                                        style={{ width: '200px' }}
                                    ></Column>
                                    <Column
                                        header="الصورة"
                                        body={(row) => (row.img ? <Chip kind="ok">فيها صورة</Chip> : <Chip kind="off">من غير صورة</Chip>)}
                                        style={{ width: '160px' }}
                                    ></Column>
                                    <Column header="تعديل / حذف"
                                    body={actionBodyTemplate}
                                    ></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AddNews;
